"use client"

import { CalendarHeart } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CalendarHeartIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CalendarHeartIcon = component(Icon)({ as: CalendarHeart })
